<template>
  <div class="ended-vote">
    <section class="hero-info">
      <img src="@images/top/ended-hero.png">
      <window-box :isHalfWidth="true" class="window-box">
        <p class="text">
          <span v-html="$t('ended.text001')" /><br><br>
          <span v-html="$t('ended.text002')" /><br><br>
          <span v-html="$t('ended.text003')" />
        </p>
      </window-box>
    </section>
    <section class="to-official">
      <BtnOfficial />
    </section>
  </div>
</template>
<script>
import WindowBox from '@components/global/window-box-blue.vue'
import BtnOfficial from '@components/global/button-official.vue'
import localeTop from '@locales/top'

export default {
  $messages: localeTop,
  components: {
    WindowBox,
    BtnOfficial,
  },
}
</script>
<style lang="scss" scoped>
.ended-vote {
  > .hero-info {
    display: flex;
    align-items: flex-start;
    > img {
      position: relative;
      z-index: 3;
      width: 295px;
      min-width: 295px;
    }
    .text {
      white-space: pre-wrap;
      text-align: center;
      display: block;
      width: 100%;
      font-size: $fs-base;
      width: 270px;
      margin: 0 auto;
    }
    .window-box {
      height: 340px;
      transform: translateX(-50px);
      margin-top: 10px;
      /deep/ .box-inner {
        display: flex;
        align-items: center;
      }
    }
  }
  > .to-official {
    margin: 40px 0 80px 0;
  }
}
</style>